import { render, staticRenderFns } from "./DaftarKontak.vue?vue&type=template&id=9dfd0b1a&scoped=true&"
import script from "./DaftarKontak.vue?vue&type=script&lang=js&"
export * from "./DaftarKontak.vue?vue&type=script&lang=js&"
import style0 from "./DaftarKontak.vue?vue&type=style&index=0&id=9dfd0b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfd0b1a",
  null
  
)

export default component.exports